import { render, staticRenderFns } from "./powerBank.vue?vue&type=template&id=073dfb76&scoped=true"
import script from "./powerBank.vue?vue&type=script&lang=js"
export * from "./powerBank.vue?vue&type=script&lang=js"
import style0 from "./powerBank.vue?vue&type=style&index=0&id=073dfb76&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073dfb76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('073dfb76')) {
      api.createRecord('073dfb76', component.options)
    } else {
      api.reload('073dfb76', component.options)
    }
    module.hot.accept("./powerBank.vue?vue&type=template&id=073dfb76&scoped=true", function () {
      api.rerender('073dfb76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/equipment/powerBank.vue"
export default component.exports